import $ from 'jquery';
import throttle from './throttle';

$(function() {
  var $strip = $('#call-to-action-strip');
  if (!$strip.length) {
    return false;
  }
  var $window = $(window);
  var popupPoint = $(document).height() / 4;
  var stripStoppingPoint = $('#footer').offset().top;

  var maybeDisplayBar = throttle(function() {
    if ($window.scrollTop() > popupPoint) {
      $strip.addClass('activated');
    }
    if ($window.scrollTop() > stripStoppingPoint) {
      $strip.addClass('static');
    } else {
      $strip.removeClass('static');
    }
  });

  $('[data-dismiss=call-to-action-strip]').click(function(event) {
    event.preventDefault();
    $strip.addClass('cta-hidden');
  });

  $window.on('scroll', maybeDisplayBar);
  maybeDisplayBar();
});
